/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Combine_TipInputs */

const en_pc_tut_combine_tip = /** @type {(inputs: Pc_Tut_Combine_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For batches, use the command line. The commands are in the automation lesson below.`)
};

const zh_pc_tut_combine_tip = /** @type {(inputs: Pc_Tut_Combine_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批量处理请使用命令行，命令见下方的自动化一课。`)
};

/**
* | output |
* | --- |
* | "For batches, use the command line. The commands are in the automation lesson below." |
*
* @param {Pc_Tut_Combine_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_combine_tip = /** @type {((inputs?: Pc_Tut_Combine_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Combine_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_combine_tip(inputs)
	return zh_pc_tut_combine_tip(inputs)
});
export { pc_tut_combine_tip as "pc.tut.combine.tip" }